/**
 * @description 通用配置
 */
const setting = require("./setting.config");
module.exports = Object.assign({}, setting);
